import React from 'react'
import './Anim.css'
const Loader = ({ loading }) => {
    return (
        <div style={{ display: loading, position: 'fixed', top: '0',left:'0', width: '100%', height: '100%', flexDirection: 'column', gap: '2rem', background: '#00000082', zIndex: '9999', alignItems: 'center', justifyContent: 'center' }}>
            <div className="square-circle-5"></div>
            <span style={{ color: 'white', fontSize: '2rem' }}>Submitting.... Please wait</span>
        </div>
    )
}

export default Loader